import React, { useState, useEffect } from 'react'
import { useQueryParams } from 'raviger'
import request from 'Root/request'

import { colors } from 'Constants'
import { getReport, getReportLevel } from '../helpers'

import { Flex } from 'lese'
import ScaleLoader from 'react-spinners/ScaleLoader'
import ReportTitle from '../components/ReportTitle'
import ArchiveOfficeReport from './components/ArchiveOfficeReport'

import { useStore } from 'laco-react'
import { ReportSortingStore } from 'Store'

export default ({ appCode }) => {
  const reportSortingState = useStore(ReportSortingStore)
  const [
    {
      startDate,
      endDate,
      officeId,
      patientRef,
      journeyId,
      showArchivedOffices
    },
    setQuery
  ] = useQueryParams()
  const [reports, setReports] = useState([])
  const [reasons, setReasons] = useState([])
  const [loading, setLoading] = useState(true)

  const title = getReportLevel(officeId, patientRef)

  useEffect(async () => {
    const reasons = await request('/info/archive-reasons/list')
    const report = await getReport('/reports/archive/get', {
      appCode,
      startDate,
      endDate,
      officeId,
      patientRef,
      showArchivedOffices,
      journeyId,
      includeAggregation: true
    })

    setReports(report)
    if (reasons.data) setReasons(reasons.data)
    setLoading(false)
  }, [])

  return (
    <>
      <ReportTitle
        title={`${title} Archive Report`}
        csvUrl="/reports/archive/csv"
        csvPayload={reportSortingState}
        appCode={appCode}
      />
      {loading && (
        <Flex xAlign yAlign height="70vh">
          <ScaleLoader color={colors.secondary} loading={loading} />
        </Flex>
      )}
      {reports.map(report => (
        <ArchiveOfficeReport report={report} reasons={reasons} />
      ))}
    </>
  )
}
